module.exports = __webpack_public_path__ + "static/add_todoist_calendars-8e7a5b5c2c9772b1c24b8a363915286d.png";